import React from "react";
import { FiAlertCircle, FiAlertTriangle, FiCheckCircle, FiInfo, FiX } from "react-icons/fi";

const ICONS = {
  success: FiCheckCircle,
  error: FiAlertCircle,
  warning: FiAlertTriangle,
  info: FiInfo,
  default: FiInfo,
};

export function AppToastIcon({ type }) {
  const Icon = ICONS[type] || ICONS.default;
  return (
    <span className={`app-toast-icon app-toast-icon--${type || "default"}`} aria-hidden="true">
      <Icon />
    </span>
  );
}

export function AppToastCloseButton({ closeToast }) {
  return (
    <button
      type="button"
      className="app-toast-close"
      onClick={closeToast}
      aria-label="Close notification"
    >
      <FiX />
    </button>
  );
}
